import {defineMessages} from 'react-intl';

const messages = defineMessages({
  forgotWorkspacePasswordDialog: {
    id: 'forgotWorkspacePasswordDialog',
    defaultMessage: 'Forgot workspace password'
  },
  contactAdmin: {
    id: 'contactAdmin',
    defaultMessage: 'Contact your workspace admin for your workspace password.'
  },
  returnToSignIn: {
    id: 'returnToSignIn',
    defaultMessage: 'Return to sign in'
  }
});

export default messages;
